
import { Cloud, Laptop } from "lucide-react";

interface HeaderProps {
  title: string;
  description: string;
  mainView: boolean;
}

const Header = ({ title, description, mainView }: HeaderProps) => {
  return (
    <div className="w-full flex flex-col items-center mb-12 animate-fade-in">
      <div className="flex justify-center items-center mb-6 w-full">
        <div className="flex items-center space-x-3">
          <div className="relative">
            <Cloud className="w-10 h-10 text-orange-500" />
            <div className="absolute -bottom-1 -right-1">
              <Laptop className="w-6 h-6 text-orange-300" />
            </div>
          </div>
          <div className="flex flex-col">
            <span className="text-2xl font-bold">CIPP</span>
            <span className="text-xs text-orange-400 block -mt-1">by CyberDrain</span>
          </div>
        </div>
      </div>
      
      <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center">
        {title}
      </h1>
      <p className="text-lg text-gray-300 max-w-2xl mx-auto text-center">
        {description}
      </p>
    </div>
  );
};

export default Header;
